/* Lluvia en Caracas: lee #ff-clima (metacampo del ERP); pinta efecto, avisos y rayos hasta valido_hasta. */
(function () {
  'use strict';
  var d = document, w = window;
  var LL = '🌧️ Está lloviendo en Caracas: tu delivery puede tardar un poco más. ¡Gracias por tu paciencia!';
  var TEXTOS = { lluvia: LL, fuerte: LL, tormenta: '⛈️ Tormenta en Caracas: los delivery pueden retrasarse' };
  var BASE = { llovizna: 35, lluvia: 80, fuerte: 140, tormenta: 140 };
  function densidad(nivel, ancho, nucleos) {
    var n = BASE[nivel] || 0;
    return ancho < 600 || (nucleos && nucleos <= 4) ? Math.round(n / 2) : n;
  }
  // Destellos cada 8-12 s (WCAG 2.3.1).
  function programarRayos(aleatorio) {
    var r = [];
    for (var i = 0; i < 5; i++) r.push(8000 + Math.round(Math.min(1, Math.max(0, aleatorio())) * 4000));
    return r;
  }
  w.FFLluvia = { programarRayos: programarRayos, densidad: densidad };
  var capa, rayo, silueta, ctx, obs, mq, cuadro = 0, reloj = 0, fin = false;
  // Suelta todo: nada vuelve a arrancar.
  function quitar() {
    fin = true;
    parar();
    d.removeEventListener('visibilitychange', alVer);
    w.removeEventListener('resize', alMedir);
    w.removeEventListener('pageshow', alVolver);
    mq && mq.removeEventListener && mq.removeEventListener('change', alVer);
    if (obs) obs.disconnect();
    d.querySelectorAll('[data-ff-lluvia-barra],[data-ff-lluvia-aviso],[data-ff-lluvia-fx]').forEach(function (e) { e.remove(); });
  }
  var c = null;
  try { var el = d.getElementById('ff-clima'); c = el ? JSON.parse(el.textContent) : null; } catch (e) { c = null; }
  var hasta = c ? Date.parse(c.valido_hasta) : NaN;
  if (!c || !BASE[c.nivel] || !(hasta > Date.now())) { quitar(); return; }
  setTimeout(quitar, Math.min(hasta - Date.now(), 2147483000));
  // bfcache
  function alVolver() { if (!(hasta > Date.now())) quitar(); }
  w.addEventListener('pageshow', alVolver);
  // Avisos: paso Entrega, carrito y /cart.
  var texto = TEXTOS[c.nivel];
  function meterAvisos() {
    var s = d.querySelectorAll('[data-fusfit-step="shipping"] [data-fusfit-ship-costo],[data-fusfit-coupon-reminder],.cart-page__items>:first-child:not([data-ff-lluvia-aviso])');
    for (var i = 0; i < s.length; i++) {
      var prev = s[i].previousElementSibling;
      if (prev && prev.hasAttribute('data-ff-lluvia-aviso')) continue;
      var p = d.createElement('p');
      p.className = 'ff-lluvia-aviso';
      p.setAttribute('role', 'status');
      p.setAttribute('data-ff-lluvia-aviso', '');
      p.textContent = texto;
      s[i].before(p);
    }
  }
  if (texto) {
    meterAvisos();
    var pend = false;
    obs = new MutationObserver(function () {
      if (pend) return;
      pend = true;
      setTimeout(function () { pend = false; meterAvisos(); }, 250);
    });
    obs.observe(d.body, { childList: true, subtree: true });
  }
  mq = w.matchMedia('(prefers-reduced-motion: reduce)');
  var inclinada = c.nivel === 'fuerte' || c.nivel === 'tormenta';
  var vel = c.nivel === 'llovizna' ? 260 : inclinada ? 1100 : 750;
  var largo = c.nivel === 'llovizna' ? 8 : inclinada ? 24 : 16;
  var dx = inclinada ? Math.tan(15 * Math.PI / 180) : 0;
  var gotas = [], ancho = 0, alto = 0, previo = 0;
  // Gotas nuevas solo si cambia el ancho (no por la barra del teléfono).
  function medir() {
    var dpr = Math.min(w.devicePixelRatio || 1, 1.5), nuevoAncho = w.innerWidth !== ancho;
    ancho = w.innerWidth; alto = w.innerHeight;
    capa.width = Math.round(ancho * dpr); capa.height = Math.round(alto * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.lineCap = 'round';
    ctx.strokeStyle = 'rgba(64,104,150,0.32)';
    ctx.lineWidth = c.nivel === 'llovizna' ? 1 : inclinada ? 1.5 : 1.2;
    if (!nuevoAncho) return;
    gotas = [];
    for (var i = densidad(c.nivel, ancho, navigator.hardwareConcurrency); i > 0; i--) gotas.push({ x: Math.random() * (ancho + 200) - 100, y: Math.random() * alto, k: 0.7 + Math.random() * 0.6 });
  }
  function alMedir() { if (capa && !fin) medir(); }
  function pintar(t) {
    var s = previo ? Math.min((t - previo) / 1000, 0.05) : 0;
    previo = t;
    ctx.clearRect(0, 0, ancho, alto);
    ctx.beginPath();
    for (var i = 0; i < gotas.length; i++) {
      var g = gotas[i], v = vel * g.k * s, l = largo * g.k;
      g.y += v; g.x += v * dx;
      if (g.y > alto) { g.y = -l; g.x = Math.random() * (ancho + 200) - 100; }
      ctx.moveTo(g.x, g.y);
      ctx.lineTo(g.x - l * dx, g.y - l);
    }
    ctx.stroke();
    cuadro = w.requestAnimationFrame(pintar);
  }
  function destello() {
    if (!d.hidden && rayo) {
      rayo.style.opacity = '0.18';
      silueta.style.opacity = '0.25';
      setTimeout(function () { rayo.style.opacity = '0'; silueta.style.opacity = '0.06'; }, 130);
    }
    tanda();
  }
  var cola = [];
  function tanda() {
    if (!cola.length) cola = programarRayos(Math.random);
    reloj = setTimeout(destello, cola.shift());
  }
  function fx(tag, nombre) {
    var e = d.createElement(tag);
    e.className = 'ff-lluvia-' + nombre;
    e.setAttribute('aria-hidden', 'true');
    e.setAttribute('data-ff-lluvia-fx', '');
    return d.body.appendChild(e);
  }
  // Sin animación en equipos modestos (velocidad 31-oct)
  var modesto = navigator.hardwareConcurrency <= 4 || navigator.deviceMemory <= 2 || (navigator.connection || {}).saveData;
  function arrancar() {
    if (fin || modesto || mq.matches || d.hidden) return;
    if (!capa) {
      capa = fx('canvas', 'capa');
      ctx = capa.getContext('2d');
      if (c.nivel === 'tormenta') {
        silueta = fx('div', 'silueta');
        silueta.innerHTML = '<svg viewBox="0 0 64 128"><path d="M38 0 8 70h20l-10 58 38-78H34z" fill="#27466e"/></svg>';
        rayo = fx('div', 'rayo');
      }
      medir();
    }
    previo = 0;
    if (!cuadro) cuadro = w.requestAnimationFrame(pintar);
    if (rayo && !reloj) tanda();
  }
  function parar() {
    if (cuadro) w.cancelAnimationFrame(cuadro);
    cuadro = 0;
    clearTimeout(reloj); reloj = 0;
    if (ctx) ctx.clearRect(0, 0, ancho, alto);
  }
  function alVer() { if (d.hidden || mq.matches) parar(); else arrancar(); }
  d.addEventListener('visibilitychange', alVer);
  w.addEventListener('resize', alMedir);
  if (mq.addEventListener) mq.addEventListener('change', alVer);
  arrancar();
})();
